module.exports = __webpack_public_path__ + "static/media/photo260.c18ffdb4.jpg";